export interface IVariablesReservation {
    reservaCodigo: string;
    reservaDataEntrada: string;
    reservaDataSaida: string;
    reservaHorarioEntrada: string;
    reservaHorarioSaida: string;
    reservaStatus: string;
    reservaStatusPagamento: string;
    reservaStatusCheckin: string;
    reservaOrigem: string;
    reservaDataCriacao: string;
    checkinDataCriacao: string;
    checkinSenhaAcomodacao: string;
    checkinSenhaAreaAcesso: string;
    acomodacaoCodigo: string;
    acomodacaoNome: string;
    acomodacaoLocalizacao: string;
    acomodacaoTipoAcesso: string;
    acomodacaoMaisInfo: string;
    acomodacaoRedeWifi: string;
    acomodacaoSenhaWifi: string;
    acomodacaoFechadura: string | null;
    acomodacaoAreasAcesso: string;
    guests: {
        name: string;
        email: string;
        phone: string;
        birth: string;
        cpf: string;
        rg: string | null;
        type: string;
        primary: boolean;
    }[];
    hoje: string;
    diaAtual: number;
    diaAtualExtenso: string;
    mesAtual: string;
    mesAtualExtenso: string;
    anoAtual: number;
    anoAtualExtenso: string;
    checkinLink: string;
    checkoutLink: string;
    checkinLinkPDF: string;
    empresaRazaoSocial: string;
    empresaNomeFantasia: string;
    empresaCNPJ: string;
    empresaEmail: string;
    empresaTelefone: string;
    empresaEndereco: string;
    acomodacaoURLCapa: string;
    linkContrato: string;
    reservaValorFatura: string;
}

function formatCPF(cpf: string): string {
    return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
}

function formatCNPJ(cnpj: string): string {
    return cnpj.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
}

function formatPhone(phone: string): string {
    const cleaned = phone.replace(/\D/g, '');
    if (cleaned.length === 11) {
        return cleaned.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
    } else if (cleaned.length === 10) {
        return cleaned.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
    }
    return phone; 
}

export const replaceVariables = (variables: IVariablesReservation, text: string) => {
    let newText = text;
    const regex = /\{\{([^}]+)\}\}/g;
    let match;
    while ((match = regex.exec(text)) !== null) {
        const variableName = match[1];
        let variableValue = variables[variableName as keyof IVariablesReservation];
        if (variableValue !== undefined) {
            if (variableName === 'hospedeCPFTitular' && typeof variableValue === 'string') {
                variableValue = formatCPF(variableValue);
            } else if (variableName === 'empresaCNPJ' && typeof variableValue === 'string') {
                variableValue = formatCNPJ(variableValue);
            } else if ((variableName === 'hospedeTelefoneTitular' || variableName === 'empresaTelefone') && typeof variableValue === 'string') {
                variableValue = formatPhone(variableValue);
            }
            newText = newText.replace(match[0], variableValue as string);
        }
    }
    return newText;
}